import {
  Component,
  Input,
  OnInit,
  OnChanges,
  SimpleChanges,
  Output,
  EventEmitter,
} from '@angular/core';
import { UntypedFormControl } from '@angular/forms';
import { SortOptionsService } from './../../services/sort-options.service';

const noop = () => {};

@Component({
  selector: 'app-reactive-toggle',
  templateUrl: './reactive-toggle.component.html',
  styleUrls: ['./reactive-toggle.component.scss'],
})
export class ReactiveToggleComponent implements OnInit {
  // eslint-disable-next-line @angular-eslint/no-output-native
  @Output() change = new EventEmitter();
  // eslint-disable-next-line @angular-eslint/no-input-rename
  @Input() fieldId: string = '';
  @Input() fieldName: string = '';
  @Input() customFormControl: UntypedFormControl;
  @Input() label: string;
  @Input() tooltipText: string;
  @Input() disabled: boolean = false;
  @Input() disabledMsg: string = '';
  @Input() fieldSize: string = 'small';
  @Input() toggleClass = '';
  @Input() formMargin: number = 3;
  @Input() toggleSize: number = 5;
  @Input() labelSize: number = 3;
  @Input() showInfoAsTooltip: boolean = false;
  @Input() showFormDivider: boolean = false;
  @Input() toggleInbuildLabel = '';
  @Input() toggleInbuildLabelPosition;
  @Input() required: boolean;

  ngOnInit(): void {
    if (!this.label) {
      this.toggleSize = 12;
      this.labelSize = 0;
    }
  }

  onChangeToggle(event) {
    this.change.emit(event);
  }
}
